<div class="margin-top-lg">
	<mat-card-title class="h5">
		COEs - Move History
		<mat-icon *ngIf="isLoading">
			<mat-spinner diameter="18"></mat-spinner>
		</mat-icon>
	</mat-card-title>
	<mat-divider> </mat-divider>

	<mat-card-content class="margin-top-lg" *ngIf="!isLoading && (!coes || coes.length === 0)">
		<h3>This child does not have any COEs.</h3>
	</mat-card-content>

	<div *ngIf="!isLoading && coes && coes.length > 0" class="margin-top-md table-responsive">
		<mat-table [dataSource]="coeTableDataSource" class="mat-elevation-z1" matSort>

			<ng-container matColumnDef="COE_PARTY_ROLES[0].PARTY_ROLES.PARTy.ORGANIZATIONS[0].REGIONS[0].CODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.COE_PARTY_ROLES[0].PARTY_ROLES.PARTy.ORGANIZATIONS[0].REGIONS[0].CODE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="COE_NUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header> COE Number </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						<a [routerLink]="['/coe/dynamic/', element.ID]" target="_blank" class="link-minified">
							{{element.COE_NUMBER}}
						</a>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="NODE_COES[0].NODE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						<node-status-table-item [(node)]="element.NODE_COES[0].NODE"
							(nodeChange)="generateUpdatedTooltip($event)"></node-status-table-item>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container
				matColumnDef="NODE_COES[0].NODE.NODE_HISTORIES[coe.NODE_COES[0].NODE.NODE_HISTORIES.length - 1].CREATED_DATE">
				<mat-header-cell *matHeaderCellDef> Updated </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div *ngIf="element.NODE_COES[0].NODE.NODE_HISTORIES && element.NODE_COES[0].NODE.NODE_HISTORIES.length > 0"
						[matTooltip]="element.UPDATED_TOOLTIP" [matTooltipPosition]="'above'">
						{{element.NODE_COES[0].NODE.NODE_HISTORIES[element.NODE_COES[0].NODE.NODE_HISTORIES.length-1].CREATED_DATE
						| cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="COE_MOVEMENT_INFORMATION[0].CITy.CITY_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Moved From </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.COE_MOVEMENT_INFORMATION[0]?.CITy?.CITY_NAME | titlecase}},
						{{element.COE_MOVEMENT_INFORMATION[0]?.CITy?.STATE.STATE_CODE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="COE_MOVEMENT_INFORMATION[1].CITy.CITY_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Moved To </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.COE_MOVEMENT_INFORMATION[1]?.CITy?.CITY_NAME | titlecase}},
						{{element.COE_MOVEMENT_INFORMATION[1]?.CITy?.STATE.STATE_CODE}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="COE_MOVES[0].RESIDENCY_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Residency Date </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.COE_MOVES[0].RESIDENCY_DATE | cleanDate | simpleDate}}
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="QUALIFYING_ARRIVAL_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Qualifying Arrival Date/Work </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						{{element.QUALIFYING_ARRIVAL_DATE | cleanDate | simpleDate}} | {{element.QUALIFYING_WORK |
						titlecase}}
					</div>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="coeDisplayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: coeDisplayedColumns;"></mat-row>
		</mat-table>

	</div>
</div>